module.exports = __webpack_public_path__ + "static/media/pin_green_employee.0416a383.png";